import { useQuery } from "@tanstack/react-query";
import { Navigate, Outlet } from "react-router-dom";
import { getMe } from "../api/Client";

/**
 * Wraps every logged-in-only route (/learn and its sub-routes). Same /me
 * check RootGate uses for "/", just the opposite branch: no session bounces
 * to /login instead of rendering the marketing page.
 */
export default function RequireAuth() {
  const { data, isLoading } = useQuery({
    queryKey: ["me"],
    queryFn: getMe,
    refetchOnMount: "always",
  });

  if (isLoading) {
    return null;
  }

  if (!data?.loggedIn) {
    return <Navigate to={"/login"} replace />;
  }

  // Signed in but hasn't finished the email code from signup yet — send them
  // back to finish that instead of into the app.
  if (!data.verified) {
    return <Navigate to={"/verify-email"} replace />;
  }

  return <Outlet />;
}
